import {
    FETCH_SHOPIFY_CATEGORIES_START,
    FETCH_SHOPIFY_CATEGORIES_SUCCESS,
    FETCH_SHOPIFY_CATEGORIES_FAILURE,
    CREATE_SHOPIFY_CATEGORY_START,
    CREATE_SHOPIFY_CATEGORY_SUCCESS,
    CREATE_SHOPIFY_CATEGORY_FAILURE,
    UPDATE_SHOPIFY_CATEGORY_START,
    UPDATE_SHOPIFY_CATEGORY_SUCCESS,
    UPDATE_SHOPIFY_CATEGORY_FAILURE,
    DELETE_SHOPIFY_CATEGORY_START,
    DELETE_SHOPIFY_CATEGORY_SUCCESS,
    DELETE_SHOPIFY_CATEGORY_FAILURE,
    UPDATE_SHOPIFY_CATEGORIES_STATUS_START,
    UPDATE_SHOPIFY_CATEGORIES_STATUS_SUCCESS,
    UPDATE_SHOPIFY_CATEGORIES_STATUS_FAILURE,
    SET_SHOPIFY_FILTERS,
    CLEAR_SHOPIFY_FILTERS,
    CHANGE_SHOPIFY_PAGINATION,
    FETCH_AVAILABLE_KEYWORDS_SUCCESS
} from '../actions';

const initialState = {
    categories: [],
    loading: false,
    error: null,
    pagination: {
        current: 1,
        pageSize: 50,
        total: 0,
        totalPages: 0
    },
    filters: {
        searchText: '',
        statusFilter: 'all',
        keywordTypeFilter: 'all'
    },
    availableKeywords: {
        title: [],
        tag: [],
        vendor: [],
        productType: []
    }
};

const shopifyCategoriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SHOPIFY_CATEGORIES_START:
        case CREATE_SHOPIFY_CATEGORY_START:
        case UPDATE_SHOPIFY_CATEGORY_START:
        case DELETE_SHOPIFY_CATEGORY_START:
        case UPDATE_SHOPIFY_CATEGORIES_STATUS_START:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_SHOPIFY_CATEGORIES_SUCCESS:
            return {
                ...state,
                categories: action.payload.categories || [],
                pagination: action.payload.pagination || state.pagination,
                filters: action.payload.filters || state.filters,
                loading: false,
                error: null
            };

        case CREATE_SHOPIFY_CATEGORY_SUCCESS:
            return {
                ...state,
                categories: [...state.categories, action.payload],
                loading: false,
                error: null
            };

        case UPDATE_SHOPIFY_CATEGORY_SUCCESS:
            return {
                ...state,
                categories: state.categories.map(category =>
                    category.id === action.payload.id ? action.payload : category
                ),
                loading: false,
                error: null
            };

        case DELETE_SHOPIFY_CATEGORY_SUCCESS:
            return {
                ...state,
                categories: state.categories.filter(category => category.id !== action.payload),
                loading: false,
                error: null
            };

        case UPDATE_SHOPIFY_CATEGORIES_STATUS_SUCCESS:
            return {
                ...state,
                categories: state.categories.map(category =>
                    action.payload.categoryIds.includes(category.id)
                        ? { ...category, isActive: action.payload.isActive }
                        : category
                ),
                loading: false,
                error: null
            };

        case FETCH_SHOPIFY_CATEGORIES_FAILURE:
        case CREATE_SHOPIFY_CATEGORY_FAILURE:
        case UPDATE_SHOPIFY_CATEGORY_FAILURE:
        case DELETE_SHOPIFY_CATEGORY_FAILURE:
        case UPDATE_SHOPIFY_CATEGORIES_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case SET_SHOPIFY_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                }
            };

        case CLEAR_SHOPIFY_FILTERS:
            return {
                ...state,
                filters: initialState.filters
            };

        case CHANGE_SHOPIFY_PAGINATION:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    current: action.payload.page,
                    pageSize: action.payload.pageSize
                }
            };

        case FETCH_AVAILABLE_KEYWORDS_SUCCESS:
            return {
                ...state,
                availableKeywords: action.payload
            };

        default:
            return state;
    }
};

export default shopifyCategoriesReducer;
